
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaicabservice() {



const cardData = {
  keyword: "Pune to Mumbai Cab Service  ",
  heading: "Skyline Cabs: Pune to Mumbai Cab Service ",
  headingDescription: "Skyline Cabs provides reliable and professionally managed Pune to Mumbai Cab Service for corporate travelers, IT professionals, families, and long-distance airport passengers. Whether you are traveling from central Pune, Kharadi, Baner, Hadapsar, or Pimpri-Chinchwad, we ensure smooth and timely connectivity to Chhatrapati Shivaji Maharaj International Airport. Our fleet includes well-maintained AC sedans, SUVs, and premium vehicles suitable for luggage-friendly long-distance travel. With experienced chauffeurs, punctual pickup scheduling, transparent fare structure, and 24x7 availability, Skyline Cabs ensures safe, comfortable, and stress-free airport transfers from Pune to Mumbai.",

  top: "Top Places to visit in Mumbai with skyline Cab",

topPlaces: [
  {
    title: "Gateway of India",
    description: "The Gateway of India, located in South Mumbai along the waterfront of Apollo Bunder, is an iconic monument built during the British Raj in 1924. Tourists arriving from Chhatrapati Shivaji Maharaj International Airport or taking sea cruises often start their Mumbai exploration here. The grand basalt arch overlooks the Arabian Sea and offers ferry services to Elephanta Caves. Its historical significance as the ceremonial entrance for British governors and royals, combined with stunning sunset views, makes it a must-visit destination for travelers seeking both heritage and photography opportunities."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive, famously called the 'Queen’s Necklace,' is a 3.6 km long boulevard along Mumbai’s Arabian Sea coastline. Travelers frequently enjoy evening walks or drives along this promenade, taking in spectacular sunset views. The area is lined with Art Deco buildings, some of which are UNESCO World Heritage Sites. Street vendors, cafes, and occasional cultural performances make it a lively yet relaxing escape from busy city life, ideal for tourists and local professionals alike."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Terminus",
    description: "Chhatrapati Shivaji Maharaj Terminus (CSMT) is a UNESCO World Heritage Site and one of the busiest railway stations in India. Its Victorian Gothic architecture combined with Indian influences is a visual treat for visitors. Tourists and business travelers arriving by train from suburban or intercity connections often marvel at the intricate stone carvings and stained-glass windows. CSMT is also a hub for Mumbai’s local culture, offering nearby street food, historical insights, and quick access to South Mumbai attractions."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is a bustling shopping street connecting the Gateway of India to the rest of South Mumbai. Tourists and local shoppers explore a mix of street markets, designer boutiques, art galleries, and iconic cafes like Leopold Cafe. Visitors traveling from the airport or railway stations frequently stop here to shop for souvenirs, handicrafts, and clothing. The vibrant atmosphere, combined with colonial-era architecture, makes it a popular destination for both leisure and cultural exploration."
  },
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park, located in Borivali, is one of the few national parks situated within a major city. Spanning over 104 square kilometers, it offers dense forests, wildlife, and the ancient Kanheri Caves. Nature enthusiasts, trekkers, and families traveling from suburban Mumbai or nearby airports visit to experience safaris, nature trails, and historical rock-cut Buddhist caves. The park also provides educational programs about conservation, making it ideal for eco-tourism and recreational trips."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is a legendary Mumbai coastline that attracts tourists, local families, and Bollywood celebrities. Visitors often come here for leisurely evening strolls, sunset photography, and sampling Mumbai’s famous street food like bhel puri and pani puri. Its proximity to luxury hotels, high-end restaurants, and entertainment hubs makes it a prime destination for travelers seeking both relaxation and vibrant local experiences."
  },
  {
    title: "Haji Ali Dargah",
    description: "Haji Ali Dargah is a 15th-century mosque and tomb located on an islet off the coast of Worli. Accessible via a narrow causeway during low tide, it is a spiritual landmark and an architectural marvel with Indo-Islamic design elements. Pilgrims, tourists, and photographers frequently visit to witness its serene ambiance and ocean views. The dargah also symbolizes Mumbai’s communal harmony and is often included in city tours highlighting heritage and culture."
  },
  {
    title: "Chor Bazaar",
    description: "Chor Bazaar, also known as the 'Thieves Market,' is one of Mumbai’s oldest and most famous flea markets. Collectors, antique enthusiasts, and tourists arrive from across India and abroad to hunt for vintage items, furniture, Bollywood memorabilia, and quirky artifacts. Its chaotic charm, bargaining culture, and proximity to Grant Road make it an intriguing destination for those looking to explore Mumbai’s local trade and street market culture."
  },
  {
    title: "Elephanta Caves",
    description: "Elephanta Caves, a UNESCO World Heritage Site on Elephanta Island in Mumbai Harbor, are accessible via ferry from the Gateway of India. These ancient rock-cut caves date back to between the 5th and 8th centuries and feature intricate sculptures of Hindu deities, particularly Lord Shiva. Tourists often combine a ferry ride with a guided exploration of the caves, enjoying both cultural heritage and scenic views of the Arabian Sea. It is an essential destination for history buffs and spiritual travelers."
  },
  {
    title: "Bandra-Worli Sea Link",
    description: "The Bandra-Worli Sea Link is a cable-stayed bridge connecting Mumbai’s western suburbs to South Mumbai, dramatically reducing travel time. Business professionals, daily commuters, and tourists alike experience this architectural marvel for its panoramic views of the sea and skyline. Driving across at sunset is particularly popular for photographers. The bridge not only serves as a crucial transport link but has become an iconic symbol of modern Mumbai engineering and urban development."
  }
],

services: [
  {
    name: "Pune to Mumbai Cab Services 24×7",
    description: "Skyline Cabs provides Pune to Mumbai Cab Services 24×7 ensuring round-the-clock intercity connectivity via the Mumbai–Pune Expressway. Our fleet includes well-maintained, air-conditioned sedans and SUVs suitable for business travel, airport transfers, and family trips. Professional chauffeurs monitor highway traffic conditions and adjust routing to maintain punctual arrival at the destination. We offer structured pickup from any Pune locality with disciplined scheduling support. Transparent pricing, real-time coordination, and reliable service management guarantee dependable 24×7 cab availability."
  },
  {
    name: "Pune to Mumbai Taxi Service 24×7",
    description: "Pune to Mumbai Taxi Service 24×7 ensures continuous availability for daytime and late-night intercity travel needs. Skyline Cabs provides sanitized and comfortable vehicles optimized for smooth expressway performance and long-distance travel. Drivers coordinate departure timing strategically to avoid congestion and maintain efficient travel schedules. We focus on punctual pickup and secure highway transit at all hours. Transparent fare structure and disciplined driving standards ensure reliable 24-hour taxi connectivity."
  },
  {
    name: "24×7 Cab Service Pune to Mumbai",
    description: "24×7 Cab Service Pune to Mumbai offers flexible travel scheduling with assured vehicle availability at any time of day or night. Skyline Cabs ensures professional chauffeur support and optimized routing for smooth intercity travel. Vehicles are air-conditioned and maintained for comfortable long-distance connectivity. Traffic monitoring and strategic departure planning guarantee punctual arrival. Transparent billing and structured service coordination ensure consistent round-the-clock cab service."
  },
  {
    name: "Pune to Mumbai Cabs 24×7",
    description: "Pune to Mumbai Cabs 24×7 service delivers dependable intercity transportation with continuous booking support. Skyline Cabs provides multiple vehicle categories including sedan, SUV, and premium options for varied travel needs. Drivers monitor traffic patterns across city and highway corridors to ensure efficient routing. Pickup coordination is managed professionally for timely departure at any hour. Transparent pricing policies and disciplined service standards ensure reliable 24-hour cab solutions."
  },
  {
    name: "Pune to Mumbai Cab Service Night",
    description: "Pune to Mumbai Cab Service Night ensures secure and comfortable intercity travel during late-night hours. Skyline Cabs provides experienced chauffeurs trained for safe highway driving with structured night travel management. Vehicles are maintained for stable expressway performance and passenger comfort. Departure scheduling is carefully aligned to ensure punctual arrival even during off-peak hours. Transparent fare policies and professional coordination guarantee dependable night cab service."
  },
  {
    name: "Pune to Mumbai Taxi Service Late Night",
    description: "Pune to Mumbai Taxi Service Late Night offers reliable transportation support for travelers requiring midnight or post-midnight departures. Skyline Cabs ensures sanitized vehicles and disciplined long-route driving standards. Drivers monitor expressway traffic conditions and maintain smooth routing for uninterrupted transit. We focus on punctual pickup and safe arrival throughout late-night travel. Transparent billing and structured booking support ensure consistent late-night taxi availability."
  },
  {
    name: "Pune to Mumbai Cab Service Early Morning",
    description: "Pune to Mumbai Cab Service Early Morning provides punctual departure scheduling for travelers requiring early-day connectivity. Skyline Cabs coordinates timely pickup from residential and corporate areas across Pune. Vehicles are air-conditioned and optimized for comfortable highway performance. Drivers align departure timing with passenger schedules to maintain efficient travel. Transparent pricing and disciplined service execution ensure dependable early-morning cab solutions."
  },
  {
    name: "Pune to Mumbai Airport Cab 24×7",
    description: "Pune to Mumbai Airport Cab 24×7 ensures reliable airport transfers aligned with flight reporting schedules at any hour. Skyline Cabs provides comfortable vehicles with adequate luggage space for domestic and international travel. Drivers monitor traffic flow and adjust routing to maintain punctual airport arrival. Pickup coordination is structured for smooth departure from Pune localities. Transparent fare structure and professional management guarantee dependable 24-hour airport connectivity."
  },
  {
    name: "Pune to Mumbai Cab Service Near Me",
    description: "Pune to Mumbai Cab Service Near Me offers convenient local pickup support with quick booking confirmation and reliable intercity travel. Skyline Cabs ensures vehicle availability across major Pune areas with optimized route planning. Drivers coordinate timely departure while monitoring highway traffic conditions. Vehicles are maintained for comfortable and safe expressway travel. Transparent pricing and structured service management ensure dependable nearby cab availability."
  },
  {
    name: "Hadapsar to Mumbai Cab Service 24×7",
    description: "Hadapsar to Mumbai Cab Service 24×7 ensures continuous intercity travel support from residential and commercial zones in Hadapsar. Skyline Cabs provides comfortable vehicles optimized for expressway connectivity with sufficient baggage space. Drivers plan departure timing strategically to avoid congestion across Hadapsar corridors. We ensure punctual arrival and disciplined highway driving standards at all hours. Transparent billing and structured service coordination guarantee reliable 24×7 cab solutions."
  },
  {
    name: "Hinjewadi to Mumbai Cab Service 24×7",
    description: "Hinjewadi to Mumbai Cab Service 24×7 delivers dependable intercity transportation tailored for IT professionals and corporate travelers. Skyline Cabs coordinates pickup from Hinjewadi phases with optimized expressway routing. Vehicles are maintained for smooth long-distance performance and passenger comfort. Drivers manage departure timing strategically to maintain punctual arrival. Transparent pricing policies and professional service standards ensure reliable round-the-clock connectivity."
  },
  {
    name: "Wakad to Mumbai Taxi Service 24×7",
    description: "Wakad to Mumbai Taxi Service 24×7 provides reliable intercity connectivity with structured pickup coordination from Wakad residential and business hubs. Skyline Cabs offers air-conditioned vehicles suitable for long-distance highway travel. Drivers monitor traffic flow and adjust routing to maintain efficient transit. Departure timing is aligned carefully for punctual arrival at any hour. Transparent fare structure and disciplined service execution ensure consistent 24-hour taxi availability."
  },
  {
    name: "Baner to Mumbai Cab Service 24×7",
    description: "Baner to Mumbai Cab Service 24×7 ensures dependable airport and city transfers with professional chauffeur coordination. Skyline Cabs provides comfortable vehicles optimized for smooth expressway performance and luggage accommodation. Drivers carefully plan departure scheduling considering Baner traffic conditions. We focus on punctual arrival and structured travel management at all hours. Transparent pricing and safety-focused standards guarantee reliable 24×7 cab connectivity."
  },
  {
    name: "Pimpri Chinchwad to Mumbai Cab Service 24×7",
    description: "Pimpri Chinchwad to Mumbai Cab Service 24×7 delivers secure and punctual intercity travel from PCMC areas with structured booking support. Skyline Cabs ensures vehicle availability and optimized expressway routing for smooth transit. Drivers align departure timing strategically based on traffic patterns and passenger schedules. Vehicles are maintained for comfortable long-distance performance. Transparent fare policies and disciplined service management ensure dependable 24-hour connectivity."
  }
],

tableData: [
  ["Pune to Mumbai Cab Services 24×7", "Pune to Mumbai Taxi Service 24×7"],
  ["24×7 Cab Service Pune to Mumbai", "Pune to Mumbai Cabs 24×7"],
  ["Pune to Mumbai Cab Service Night", "Pune to Mumbai Taxi Service Late Night"],
  ["Pune to Mumbai Cab Service Early Morning", "Pune to Mumbai Airport Cab 24×7"],
  ["Pune to Mumbai Cab Service Near Me", "Hadapsar to Mumbai Cab Service 24×7"],
  ["Hinjewadi to Mumbai Cab Service 24×7", "Wakad to Mumbai Taxi Service 24×7"],
  ["Baner to Mumbai Cab Service 24×7", "Pimpri Chinchwad to Mumbai Cab Service 24×7"]
],

whychoose: [
  {
    WhyChooseheading: "Expert Pune Pickup Knowledge",
    WhyChoosedescription: "Skyline Cab drivers are highly familiar with Pune’s main roads, traffic-prone areas, and popular pickup points such as Koregaon Park, Kalyani Nagar, Swargate, and Hinjewadi. This knowledge allows them to select the most efficient route, avoid congestion, and ensure a smooth start to your Pune to Mumbai journey. With real-time traffic monitoring, passengers can rely on timely pickups and a hassle-free ride experience."
  },
  {
    WhyChooseheading: "Professional Expressway and Highway Driving",
    WhyChoosedescription: "Our chauffeurs are trained for long-distance travel, particularly on the Pune–Mumbai Expressway. They maintain safe driving speeds, smooth handling, and proper lane discipline throughout the journey. Familiarity with toll plazas, highway diversions, and traffic updates ensures Skyline Cab provides a secure, comfortable, and punctual ride from Pune to Mumbai, even during peak travel hours."
  },
  {
    WhyChooseheading: "Punctual and Reliable Service",
    WhyChoosedescription: "Skyline Cab prioritizes timely pickups and arrivals, ensuring that passengers reach their Mumbai destination as scheduled. We carefully plan travel times by factoring in traffic conditions, distance, and any stop requirements, eliminating last-minute stress. Whether for airport transfers, business trips, or personal travel, our service guarantees on-time reliability."
  },
  {
    WhyChooseheading: "Transparent Fare Structure",
    WhyChoosedescription: "We provide upfront pricing for Pune to Mumbai cab services, including tolls, driver allowances, and applicable taxes. There are no hidden fees, allowing passengers to plan their travel budget confidently. Skyline Cab’s transparent fare policy ensures trust and clarity for all types of intercity trips."
  },
  {
    WhyChooseheading: "24/7 Availability for All Travelers",
    WhyChoosedescription: "Our service operates around the clock, catering to early morning, late-night, and emergency trips. Skyline Cab’s 24/7 support team ensures bookings, driver assignments, and real-time updates are available whenever you need them, providing peace of mind and convenience for every journey."
  },
  {
    WhyChooseheading: "Comfortable and Sanitized AC Vehicles",
    WhyChoosedescription: "Skyline Cab offers a fleet of well-maintained, air-conditioned cars designed for long-distance comfort. Spacious seating, ample luggage space, and regular sanitation make every ride safe, hygienic, and comfortable for families, solo travelers, and corporate passengers alike."
  },
  {
    WhyChooseheading: "Corporate and Family-Friendly Service",
    WhyChoosedescription: "We cater to business executives, leisure travelers, and families. Our courteous drivers assist with luggage and provide a smooth, professional ride. Skyline Cab combines reliability, comfort, and punctuality, making it ideal for both corporate travel and personal trips from Pune to Mumbai."
  },
  {
    WhyChooseheading: "Dedicated Customer Support",
    WhyChoosedescription: "From booking to drop-off, our customer support team actively manages your trip, providing live updates, driver contact information, and immediate assistance for any schedule changes. Skyline Cab ensures a seamless, stress-free, and dependable Pune to Mumbai travel experience every time."
  }
]

}

const faqData = [
    {
        id: 1,
        question: 'How can I complete Pune to Mumbai Cab Booking Online with Skyline Cabs?',
        answer:
            'Completing your Pune to Mumbai Cab Booking Online with Skyline Cabs is quick, secure, and hassle-free. Simply visit our website or mobile app, enter Pune as your pickup location and Mumbai as your drop destination, choose your preferred vehicle, and confirm your ride instantly. You will receive immediate booking confirmation along with complete driver and vehicle details. Our smooth online booking system ensures reliable intercity travel without last-minute complications.',
    },
    {
        id: 2,
        question: 'Is Pune to Mumbai Cab Booking Online available 24/7?',
        answer:
            'Yes, Skyline Cabs provides 24/7 Pune to Mumbai Cab Booking Online service for early morning, late-night, and same-day travel needs. Whether you are traveling for business, leisure, or airport transfers, our professional drivers ensure punctual pickup and comfortable highway travel via the Mumbai-Pune Expressway.',
    },
    {
        id: 3,
        question: 'What vehicle options are available for Pune to Mumbai Cab Booking Online?',
        answer:
            'We offer a wide range of vehicles including Swift Dzire, Ertiga, Innova Crysta, and premium SUVs for Pune to Mumbai Cab Booking Online. You can select an economical sedan for budget travel or choose a spacious SUV for family and group journeys. All vehicles are air-conditioned, well-maintained, and driven by experienced chauffeurs for safe long-distance travel.',
    },
    {
        id: 4,
        question: 'How much is the Pune to Mumbai Cab Booking Online fare?',
        answer:
            'The Pune to Mumbai Cab Booking Online fare depends on the vehicle type, travel date, and trip option (one-way or round trip). Skyline Cabs follows a transparent pricing policy where the final fare is clearly displayed before booking confirmation. The fare includes driver allowance and applicable charges with no hidden costs.',
    },
    {
        id: 5,
        question: 'Is one-way Pune to Mumbai Cab Booking Online available?',
        answer:
            'Yes, Skyline Cabs offers affordable one-way Pune to Mumbai Cab Booking Online service. You only pay for the distance traveled without unnecessary return charges. This option is ideal for business travelers, airport transfers, and single-direction travel needs.',
    },
    {
        id: 6,
        question: 'How long does it take to travel from Pune to Mumbai by cab?',
        answer:
            'The journey from Pune to Mumbai typically takes around 3 to 4 hours depending on traffic and travel time. Our experienced drivers use the Mumbai-Pune Expressway to ensure smooth, safe, and comfortable intercity travel with minimal delays.',
    },
    {
        id: 7,
        question: 'Is online payment available for Pune to Mumbai Cab Booking Online?',
        answer:
            'Yes, Skyline Cabs supports secure online payment options including UPI, credit cards, debit cards, and net banking. Once your payment is successfully completed, you receive instant booking confirmation along with trip and driver details for complete peace of mind.',
    },
    {
        id: 8,
        question: 'Can I pre-book Pune to Mumbai Cab Booking Online in advance?',
        answer:
            'Absolutely. You can pre-book your Pune to Mumbai Cab Booking Online for any future date and time. Advance booking ensures guaranteed vehicle availability, especially during weekends, holidays, and peak travel seasons.',
    },
    {
        id: 9,
        question: 'Is Pune to Mumbai Cab Booking Online suitable for corporate travel?',
        answer:
            'Yes, our Pune to Mumbai Cab Booking Online service is highly preferred by corporate professionals and business travelers. We provide punctual pickups, professional chauffeurs, clean vehicles, and reliable service for executive and business trips.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Pune to Mumbai Cab Booking Online?',
        answer:
            'Skyline Cabs is trusted for Pune to Mumbai Cab Booking Online because of our transparent pricing, professional drivers, sanitized vehicles, punctual service, and 24x7 customer support. We focus on delivering safe, reliable, and comfortable intercity travel experiences every time.',
    },
];

const someReviews = [
    {
        name: "Mr. Vivek Kulkarni",
        rating: 5,
        review: "Booked Pune to Mumbai Cab Booking Online with Skyline Cabs for my business meeting. The driver was punctual, the vehicle was clean, and the journey via expressway was smooth. Highly reliable intercity cab service!"
    },
    {
        name: "Ms. Neha Patil",
        rating: 4,
        review: "Very dependable Pune to Mumbai Cab Booking Online service. Transparent pricing and comfortable ride made our trip stress-free. Skyline Cabs provides professional and timely service."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cab Service",
  "image": "https://skylinecabs.com/assets/images/pune-to-mumbai-cab-service.jpg",
  "description": "Book Pune to Mumbai Cab Service with Skyline Cabs for 24×7 safe, comfortable, and reliable travel. AC, Innova Crysta, Ertiga, and Sedan cabs available for one-way, round-trip, night, and early morning trips from Hadapsar, Hinjewadi, Wakad, Baner, Pimpri Chinchwad, and other Pune locations to Mumbai and Mumbai Airport.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2699",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-mumbai-cab-service"
  }
};


      


    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Cab Service 24×7 | AC Cab with Driver | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Cab Service with Skyline Cabs for 24×7 safe, comfortable, and reliable travel. AC, Innova Crysta, Ertiga, and Sedan cabs available for one-way, round-trip, night, and early morning trips from Pune to Mumbai and Mumbai Airport." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Cab Services 24×7, Pune to Mumbai Taxi Service 24×7, 24×7 Cab Service Pune to Mumbai, Pune to Mumbai Cabs 24×7, Pune to Mumbai Cab Service Night, Pune to Mumbai Taxi Service Late Night, Pune to Mumbai Cab Service Early Morning, Pune to Mumbai Airport Cab 24×7, Pune to Mumbai Cab Service Near Me, Hadapsar to Mumbai Cab Service 24×7, Hinjewadi to Mumbai Cab Service 24×7, Wakad to Mumbai Taxi Service 24×7, Baner to Mumbai Cab Service 24×7, Pimpri Chinchwad to Mumbai Cab Service 24×7, Skyline Cabs Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/145.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaicabservice;